import { render } from "./dataModelMain.vue?vue&type=template&id=7d6a2375&scoped=true"
import script from "./dataModelMain.vue?vue&type=script&lang=js"
export * from "./dataModelMain.vue?vue&type=script&lang=js"

import "./dataModelMain.vue?vue&type=style&index=0&id=7d6a2375&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.25_vue@3.5.25_typescript@5.4.2__webpack@5.103.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d6a2375"]])

export default __exports__